module.exports = __webpack_public_path__ + "static/img/left-top-row-1.c88e7032.png";